import { styled, css } from '@vebox/etui-system';
import { omit } from '../utilities/omit.js';
import { Component, createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Th as Th$1 } from '@vebox/etui-system-elements';
import { Resizable as Resizable$1 } from 'react-resizable';

const _excluded = ["onClick", "theme"];
const Th = styled(Th$1).attrs(_ref => {
  var _props$className, _props$className2, _props$className3;
  let {
      onClick,
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const isEllipsis = (_props$className = props.className) === null || _props$className === void 0 ? void 0 : _props$className.includes('danfoss-table-cell-ellipsis');
  const isFixLeft = (_props$className2 = props.className) === null || _props$className2 === void 0 ? void 0 : _props$className2.includes('danfoss-table-cell-fix-left');
  const isFixLeftLast = (_props$className3 = props.className) === null || _props$className3 === void 0 ? void 0 : _props$className3.includes('danfoss-table-cell-fix-left-last');
  return _objectSpread2({
    position: 'relative',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSizeSmall,
    fontWeight: theme.typography.fontWeightRegular,
    p: `${theme.spacing.sm}px ${theme.spacing.sm}px`,
    color: theme.palette.text.secondary,
    borderBottom: `1px solid ${theme.palette.divider}`,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    textAlign: 'left',
    cursor: onClick ? 'pointer' : 'normal',
    bg: theme.palette.common.white,
    isEllipsis,
    isFixLeft,
    isFixLeftLast
  }, props);
})`
  transition: background 0.2s ease;

  ${({
  isEllipsis
}) => isEllipsis && css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `};

  ${({
  isFixLeft
}) => isFixLeft && css`
      z-index: 1;
    `};

  ${({
  isFixLeftLast
}) => isFixLeftLast && css`
      ::after {
        pointer-events: none;
        content: '';
        transition: box-shadow 0.3s;
        position: absolute;
        top: 0;
        bottom: -1px;
        width: 20px;
        right: -1px;
        transform: translateX(100%);
      }
    `}
`;

const Resizable = styled(Resizable$1)`
  .react-resizable {
    position: relative;
  }

  .react-resizable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+');
    background-position: bottom right;
    padding: 0 3px 3px 0;
  }

  .react-resizable-handle-sw {
    bottom: 0;
    left: 0;
    cursor: sw-resize;
    transform: rotate(90deg);
  }
  .react-resizable-handle-se {
    bottom: 0;
    right: 0;
    cursor: se-resize;
  }
  .react-resizable-handle-nw {
    top: 0;
    left: 0;
    cursor: nw-resize;
    transform: rotate(180deg);
  }
  .react-resizable-handle-ne {
    top: 0;
    right: 0;
    cursor: ne-resize;
    transform: rotate(270deg);
  }
  .react-resizable-handle-w,
  .react-resizable-handle-e {
    top: 50%;
    margin-top: -10px;
    cursor: ew-resize;
  }
  .react-resizable-handle-w {
    left: 0;
    transform: rotate(135deg);
  }
  .react-resizable-handle-e {
    right: 0;
    transform: rotate(315deg);
  }
  .react-resizable-handle-n,
  .react-resizable-handle-s {
    left: 50%;
    margin-left: -10px;
    cursor: ns-resize;
  }
  .react-resizable-handle-n {
    top: 0;
    transform: rotate(225deg);
  }
  .react-resizable-handle-s {
    bottom: 0;
    transform: rotate(45deg);
  }
`;

function createHeaderCell(styles) {
  class HeaderCell extends Component {
    constructor(props) {
      super(props);
      this.store = this.props.store;
    }
    render() {
      const {
        isResizable,
        width,
        onResize
      } = this.props;
      const rowProps = omit(this.props, ['prefixCls', 'rowKey', 'store', 'isResizable', 'onResize']);
      const handleResizeColumn = (e, data) => {
        onResize(e, data);
      };
      if (isResizable && width) {
        return /*#__PURE__*/createElement(Resizable, {
          width: width,
          height: 0,
          onResize: handleResizeColumn
        }, /*#__PURE__*/createElement(Th, _extends({}, rowProps, styles), this.props.children));
      }
      return /*#__PURE__*/createElement(Th, _extends({}, rowProps, styles), this.props.children);
    }
  }
  return HeaderCell;
}

export default createHeaderCell;
